<div class="search-input-container" [class.fixed-width]="fixedWidth" (click)="$event.target === $event.currentTarget && inputElement.focus()">
  @if (leftIconAction) {
    <button
      class="action-button left-action"
      [disabled]="isSendingMessage"
      [ngClass]="{ 'empty': isSendingMessage, 'black-background': showBlackButtons }"
      (click)="executeLeftIconAction()">
      <img [src]="leftIcon" />
    </button>
  } @else if (icon) {
    <div class="search-icon">
      <tidy-image [src]="icon" />
    </div>
  }

  <textarea
    #inputElement
    class="search-input"
    [ngModel]="value"
    (ngModelChange)="onInputChange($event)"
    [placeholder]="placeholder | translate"
    (keydown)="onKeyDown($event)"
    rows="1"
  ></textarea>

  @if (speakMode && rightIconAction) {
    @if (isVoiceActive) {
      <button
        class="speak-send-button stop-mode"
        (click)="executeSpeakAction()">
        <div class="ssb-text-wrapper">Stop</div>
        <div class="ssb-icon-wrapper">
          <svg class="ssb-morph-icon" viewBox="0 0 24 24" fill="currentColor">
            <rect x="6" y="6" width="12" height="12" rx="2" />
          </svg>
        </div>
      </button>
    } @else {
      <button
        class="speak-send-button"
        [class.send-mode]="!isInputEmpty || hasAttachment"
        [disabled]="isSendingMessage"
        (click)="isInputEmpty && !hasAttachment ? executeSpeakAction() : executeRightIconAction()">
        <div class="ssb-text-wrapper">Speak</div>
        <div class="ssb-icon-wrapper">
          <svg class="ssb-morph-icon ssb-mic-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <g class="ssb-mic-head-group">
              <path class="ssb-morph-main" d="M 9 5 C 9 3.34 10.34 2 12 2 C 13.66 2 15 3.34 15 5 L 15 10 C 15 11.66 13.66 13 12 13 C 10.34 13 9 11.66 9 10 Z" />
            </g>
            <path class="ssb-morph-u" d="M 19 10 v 2 a 7 7 0 0 1 -14 0 v -2" />
            <line class="ssb-morph-stand" x1="12" y1="19" x2="12" y2="22" />
          </svg>
          <svg class="ssb-morph-icon ssb-send-icon" viewBox="0 0 24 24" fill="currentColor" stroke="none">
            <path d="M 3 3 C 6 4.5 9 6 12 7.5 C 15 9 18 10.5 21 12 L 3 21 C 4.33 18 5.66 15 7 12 C 5.66 9 4.33 6 3 3 Z" />
          </svg>
        </div>
      </button>
    }
  }

  @if (!speakMode && rightIconAction) {
    <button
      class="action-button right-action"
      [disabled]="isSendingMessage || (isInputEmpty && !hasAttachment)"
      [ngClass]="{ 'empty': (isInputEmpty && !hasAttachment) || isSendingMessage, 'black-background': showBlackButtons }"
      (click)="executeRightIconAction()">
      <img src="assets/img/send-message.svg" />
    </button>
  }

  @if (!rightIconAction && !isInputEmpty) {
    <button
      class="clear-button"
      (click)="clearInput()">
      <mat-icon>close</mat-icon>
    </button>
  }
</div>
